module.exports = __webpack_public_path__ + "media/images/Community_Logo-d0e6163ce4221d08e215b3bd633852c8.gif";